import { IdsInput } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function deleteEndOfJourneyTemplates(input: IdsInput) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API['end-of-journey-templates'].delete.url, null), input)
    )
    .delete()
}
